// client/src/components/public/PublicContact.js — the office's public phone numbers and
// emails (owner, 5 Oct 2026), kept per site in Virtual Office Settings (brokerage_settings
// public_phone_main, public_phone_secondary, public_email, public_email_office) and served
// by /api/public/office-info as `contact`. Shown in the footer and on the home page.
import React from 'react';

// Illinois: until the settings load (or if none are set), the long-standing front desk number and emails.
// The main number is not hard-coded: it is set in Virtual Office Settings.
export const IL_CONTACT_FALLBACK = { phone_secondary: '(773) 205-5493', email: 'info@bizrec.net', email_office: 'office@businessrealestatecorp.com' };

const telHref = (n) => `tel:${String(n).replace(/[^\d+]/g, '')}`;

/** The contact lines that have a value: [{ label, value, href }]. */
export const contactLines = (contact) => {
    const c = contact || {};
    return [
        c.phone_main && { label: 'Main', value: c.phone_main, href: telHref(c.phone_main) },
        c.phone_secondary && { label: 'Secondary', value: c.phone_secondary, href: telHref(c.phone_secondary) },
        c.email && { label: 'Email', value: c.email, href: `mailto:${c.email}` },
        c.email_office && { label: 'Office', value: c.email_office, href: `mailto:${c.email_office}` },
    ].filter(Boolean);
};

/** One line per number/email: "Main: (773) 762-4759" with a tap-to-call / mail link. */
export const ContactList = ({ contact, lineClass = '', linkClass = '' }) => (
    <>
        {contactLines(contact).map((l) => (
            <p key={l.label} className={lineClass}>
                {l.label}: <a href={l.href} className={linkClass}>{l.value}</a>
            </p>
        ))}
    </>
);
